import type { StaticImageData } from "next/image";

// Public URLs with intrinsic dimensions keep next/image optimization and layout stability.
// See documents/IMAGE_ASSETS.md for naming and maintenance conventions.

export const PROFILE_IMAGES = {
    alternatePortrait: {
        src: "/images/profile/archive/emran-hejazi-alternate.png",
        width: 1254,
        height: 1254,
    },
    previousPortrait: {
        src: "/images/profile/archive/emran-hejazi-previous.png",
        width: 1024,
        height: 1536,
    },
    portrait: {
        src: "/images/profile/emran-hejazi.png",
        width: 1254,
        height: 1254,
    },
} satisfies Record<string, StaticImageData>;

export const DECORATIVE_IMAGES = {
    materialElement: {
        src: "/images/decorative/material-element.png",
        width: 2048,
        height: 1146,
    },
} satisfies Record<string, StaticImageData>;

export const EXPERIENCE_LOGOS = {
    heldio: {
        src: "/images/experiences/heldio-logo.webp",
        width: 1080,
        height: 1080,
    },
} satisfies Record<string, StaticImageData>;

export const PROJECT_LOGOS = {
    atlasMall: {
        src: "/images/projects/atlas-mall-logo.webp",
        width: 1080,
        height: 1080,
    },
    callBlaze: {
        src: "/images/projects/call-blaze-logo.webp",
        width: 1080,
        height: 1080,
    },
    infraredBridge: {
        src: "/images/projects/infrared-bridge-logo.webp",
        width: 1080,
        height: 1080,
    },
    inkart: {
        src: "/images/projects/inkart-logo.webp",
        width: 1080,
        height: 1080,
    },
    sofreh: {
        src: "/images/projects/sofreh-logo.webp",
        width: 1080,
        height: 1080,
    },
    solarMonitoring: {
        src: "/images/projects/solar-monitoring-logo.webp",
        width: 1080,
        height: 1080,
    },
    sourena: {
        src: "/images/projects/sourena-logo.webp",
        width: 1080,
        height: 1080,
    },
    tebasghari: {
        src: "/images/projects/tebasghari-logo.webp",
        width: 1080,
        height: 1080,
    },
    tomorrowsCuisine: {
        src: "/images/projects/tomorrows-cuisine-logo.webp",
        width: 1080,
        height: 1080,
    },
    zarinElectronic: {
        src: "/images/projects/zarin-electronic-logo.webp",
        width: 1080,
        height: 1080,
    },
    zire20: {
        src: "/images/projects/zire20-logo.webp",
        width: 1080,
        height: 1080,
    },
} satisfies Record<string, StaticImageData>;

export const TECH_LOGOS = {
    git: {
        src: "/images/technologies/git-logo.webp",
        width: 1500,
        height: 1500,
    },
    github: {
        src: "/images/technologies/github-logo.webp",
        width: 1500,
        height: 1500,
    },
    html5: {
        src: "/images/technologies/html5-logo.webp",
        width: 1500,
        height: 1500,
    },
    java: {
        src: "/images/technologies/java-logo.webp",
        width: 1500,
        height: 1500,
    },
    javascript: {
        src: "/images/technologies/javascript-logo.webp",
        width: 1500,
        height: 1500,
    },
    kotlin: {
        src: "/images/technologies/kotlin-logo.webp",
        width: 1500,
        height: 1500,
    },
    mongodb: {
        src: "/images/technologies/mongodb-logo.webp",
        width: 1500,
        height: 1500,
    },
    nodejs: {
        src: "/images/technologies/nodejs-logo.webp",
        width: 1500,
        height: 1500,
    },
    npm: {
        src: "/images/technologies/npm-logo.webp",
        width: 1500,
        height: 1500,
    },
    prettier: {
        src: "/images/technologies/prettier-logo.webp",
        width: 1500,
        height: 1500,
    },
    react: {
        src: "/images/technologies/react-logo.webp",
        width: 1500,
        height: 1500,
    },
    redis: {
        src: "/images/technologies/redis-logo.webp",
        width: 1500,
        height: 1500,
    },
    sass: {
        src: "/images/technologies/sass-logo.webp",
        width: 1500,
        height: 1500,
    },
    sentry: {
        src: "/images/technologies/sentry-logo.webp",
        width: 1500,
        height: 1500,
    },
    tailwind: {
        src: "/images/technologies/tailwind-logo.webp",
        width: 1500,
        height: 1500,
    },
    typescript: {
        src: "/images/technologies/typescript-logo.webp",
        width: 1500,
        height: 1500,
    },
    ubuntu: {
        src: "/images/technologies/ubuntu-logo.webp",
        width: 1500,
        height: 1500,
    },
    webassembly: {
        src: "/images/technologies/webassembly-logo.webp",
        width: 1500,
        height: 1500,
    },
} satisfies Record<string, StaticImageData>;
